<template>
  <datatable :type="'workers'" :rowData="workers" :compliance="'recruitment'" :loadingMessage="loadingMessage"
             :noRowsMessage="noRowsMessage" :columns="columns"
             :paginationSize="50"></datatable>
</template>
<script>
import datatable from "datatables/datatable";

export default {
  name: "worker_compliance",
  components: {
    datatable,
  },
  data() {
    return {
      workers: null,
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Found',
      columns: [],
    }
  },
  beforeMount() {
    if (process.env.MIX_CRM_TYPE === 'recruitment') {
      this.columns = []
    }
    else if (process.env.MIX_CRM_TYPE === 'payroll') {
      this.columns = [
          {headerName: 'Company Name', minWidth: 250, maxWidth: 300, pinned: 'left', field: 'company_name'},
          {headerName: 'Ref', minWidth: 80, maxWidth: 350, pinned: 'left', field: 'internal_finance_ref'},
          {headerName: 'Surname', minWidth: 100, maxWidth: 350, pinned: 'left', field: 'surname'},
          {headerName: 'First Name', minWidth: 100, maxWidth: 350, pinned: 'left', field: 'first_name'},

          {headerName: 'Valid Entity Test', minWidth: 125, maxWidth: 350, field: 'valid_entity_test', valueGetter: this.formatBoolean,},
          {headerName: 'Paid with ID', minWidth: 125, maxWidth: 350, field: 'paid_with_id', valueGetter: this.formatBoolean},
          {headerName: 'CIS OK', minWidth: 125, maxWidth: 350, field: 'cis_ok', valueGetter: this.formatBoolean},
          {headerName: 'Correct Information', minWidth: 125, maxWidth: 350, field: 'correct_information', valueGetter: this.formatBoolean},


          {headerName: 'registered date', minWidth: 200, maxWidth: 350, field: 'registered_date'},
          {headerName: 'phone number', minWidth: 125, maxWidth: 350, field: 'phone_number'},
          {headerName: 'check received paid', minWidth: 125, maxWidth: 350, field: 'check_received_paid', valueGetter: this.formatBoolean},
          {headerName: 'check has id', minWidth: 125, maxWidth: 350, field: 'check_has_id', valueGetter: this.formatBoolean},
          {headerName: 'check has proof of address', minWidth: 125, maxWidth: 350, field: 'check_has_proof_of_address', valueGetter: this.formatBoolean},
          {headerName: 'check has right to work', minWidth: 125, maxWidth: 350, field: 'check_has_right_to_work', valueGetter: this.formatBoolean},
          {headerName: 'check has settlement code', minWidth: 125, maxWidth: 350, field: 'check_has_settlement_code', valueGetter: this.formatBoolean},
          {headerName: 'check has biometric', minWidth: 125, maxWidth: 350, field: 'check_has_biometric', valueGetter: this.formatBoolean},
          {headerName: 'country name', minWidth: 200, maxWidth: 350, field: 'country_name'},
          {headerName: 'compliancy score', minWidth: 125, maxWidth: 350, field: 'compliancy_score', valueFormatter: this.formatPercent},
      ]
    }
  },
    mounted() {
        this.get_workers();
    },
    methods: {
        get_workers() {
            axios.get(this.crmApiPath + 'worker/compliance/check').then(res => this.workers = res.data);
        },
        formatBoolean(params) {
            if(params.data[params.colDef.field] === 1) {
              return 'Yes';
            }

            return 'No';
        },
        formatPassFail(params) {
            if(params.value == 1) {
                return 'Pass';
            }

            return 'Fail';
        },
        formatPercent(params) {
            return (Math.round(params.value*100)).toFixed(0) + '%';
        }
    }
}
</script>

<style scoped>

</style>
